import { PropTypes } from 'prop-types';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DateField from '../../form/DateField';
import TextField from '../../form/TextField';
import GBIButton from '../../util/buttons/components/GBIButton';
import './animals-action-form.scss';
import { slaughterAnimals } from '../actions';
import { getSelectedAnimals } from '../reducer';

const AnimalCuttingForm = ({ close, count }) => {
  const [ cuttingPlantNumber, setCuttingPlantNumber ] = useState('');
  const [ cuttingDate, setDate ] = useState(null);
  const selectedAnimals = useSelector(getSelectedAnimals);
  const dispatch = useDispatch();
  const buttonClass = cuttingPlantNumber && cuttingDate ? '' : 'disabled';
  const submit = () => {
    if (cuttingPlantNumber && cuttingDate) {
      dispatch(slaughterAnimals(
        selectedAnimals.map(animal => animal.id),
        null,
        cuttingDate,
        null,
        cuttingPlantNumber));
    }
    close();
  };
  const text = count > 1 ?
    `Fill in the cutting details for these ${count} animals` :
    'Fill in the cutting details for this animal';
  return (
    <div className="animals-action-form">
      <h4 className="mini-title">Update</h4>
      <h2 className="caption">Record Cutting</h2>
      <p className="intro">{ text }</p>
      <div className="intro-divider"></div>
      <TextField name="Cutting Plant Reference Number"
        testId="cutting-plant-input"
        value={ cuttingPlantNumber }
        update={ setCuttingPlantNumber } />
      <DateField name="Date of Cutting"
        testId="date-input"
        update={ d => setDate(new Date(d)) }
        value={ cuttingDate } />
      <div className="button-row">
        <GBIButton label="cancel" onClick={ close } />
        <GBIButton label="save"
          className={ buttonClass }
          testId="save-button"
          onClick={ submit } />
      </div>
    </div>
  );
};

AnimalCuttingForm.propTypes = {
  close: PropTypes.func,
  count: PropTypes.number
};

export default AnimalCuttingForm;
